/**
 * StatCard — KPI card used across the Dashboard. Pure presentational.
 */
export default function StatCard({ label, value, sublabel, icon: Icon, color = "#3B82F6", testid, href, tooltip }) {
  const inner = (
    <div className="flex items-start justify-between">
      <div>
        <div className="text-[11px] uppercase tracking-wider text-[#6B7280] font-semibold">{label}</div>
        <div className="text-[26px] font-bold text-[#111827] mt-1.5 leading-none">{value}</div>
        {sublabel && <div className="text-[12px] text-[#6B7280] mt-1.5">{sublabel}</div>}
      </div>
      <div
        className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0"
        style={{ background: `${color}1A`, color }}
      >
        <Icon className="w-5 h-5" />
      </div>
    </div>
  );
  if (href) {
    return (
      <a
        data-testid={testid}
        href={href}
        title={tooltip}
        className="al-card p-5 block cursor-pointer hover:border-[#3B82F6] focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
      >
        {inner}
      </a>
    );
  }
  return (
    <div data-testid={testid} className="al-card p-5">
      {inner}
    </div>
  );
}
